import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Grid,
  List,
  Globe,
} from '@picsio/ui/dist/icons';
import localization from '../../shared/strings';
import DropOpener from '../toolbars/DropOpener';
import DropItem from '../DropItem';
import { changeCatalogViewMode, changeCatalogViewItemSize } from '../../store/actions/main';
import * as utils from '../../shared/utils';
import Logger from '../../services/Logger';
import picsioConfig from '../../../../../config';

const CatalogViewMode = (props) => {
  const { openOnClick = false, leftFilter = false} = props;
  const { isProofing } = picsioConfig;
  const catalogViewMode = useSelector((state) => state.main.catalogViewMode);
  const catalogViewItemSize = useSelector((state) => state.main.catalogViewItemSize);
  const isClipboardView = useSelector((state) => state.router?.location?.pathname === '/selectedAssets');
  const dispatch = useDispatch();

  useEffect(() => {
    if (isClipboardView && catalogViewMode === 'geo') {
      dispatch(changeCatalogViewMode('grid'));
      Logger.log('UI', 'ChangeViewMode', utils.capitalizeFirstLetter('grid'));
    }
  }, [isClipboardView, catalogViewMode, dispatch]);

  const handleChangeMode = useCallback((mode) => {
    dispatch(changeCatalogViewMode(mode));
    Logger.log('User', 'ChangeViewMode', utils.capitalizeFirstLetter(mode));
  }, [dispatch]);

  const handleChangeSize = useCallback((mode) => {
    dispatch(changeCatalogViewItemSize(mode));
    Logger.log('User', 'ChangeViewModeSize', mode);
  }, [dispatch]);

  const toogleSize = useCallback(() => {
    if (catalogViewMode !== 'list') handleChangeMode('list');
    if (catalogViewItemSize === 1) {
      handleChangeSize(1.5);
    } else if (catalogViewItemSize === 1.5) {
      handleChangeSize(2);
    } else if (catalogViewItemSize === 2 || !catalogViewItemSize) {
      handleChangeSize(1);
    }
  }, [catalogViewMode, catalogViewItemSize, handleChangeSize, handleChangeMode]);

  const mainIcon = useCallback(() => {
    if (catalogViewMode === 'geo') return <Globe />;
    if (catalogViewMode === 'list') return <List />;
    return <Grid />;
  }, [catalogViewMode]);

  return (
    <DropOpener
      icon={mainIcon}
      id="button-viewMode"
      additionalClass="mobileNotVisible toolbarButtonDropdown dropdownSort"
      name="View type"
      openOnClick={openOnClick}
      leftFilter={leftFilter}
      left
    >
      <DropItem
        icon={() => <Grid />}
        id="viewModeGrid"
        text={localization.TOOLBARS.textGrid}
        isActive={catalogViewMode === 'grid'}
        onClick={() => handleChangeMode('grid')}
      />
      <DropItem
        icon={() => <List />}
        id="viewModeList"
        text={localization.TOOLBARS.textList}
        sortViewMode
        isActive={catalogViewMode === 'list'}
        onClick={toogleSize}
        handleChangeCatalogViewItemSize={handleChangeSize}
        handleChangeCatalogViewMode={handleChangeMode}
        catalogViewItemSize={catalogViewItemSize}
        sizeText={localization.TOOLBARS.textListSize}
        catalogViewMode="list"
      />
      <If condition={!isProofing}>
        <DropItem
          icon={() => <Globe />}
          id="viewModeMap"
          disabled={isClipboardView}
          tooltip={isClipboardView ? localization.TOOLBARS.tooltipMapNotAllowed : null}
          text={localization.TOOLBARS.textMap}
          isActive={catalogViewMode === 'geo'}
          onClick={isClipboardView ? null : () => handleChangeMode('geo')}
        />
      </If>
    </DropOpener>
  );
};

export default CatalogViewMode;
